import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const Divider = ({ text, hasTopSpacing }) => (
  <S.Divider hasTopSpacing={hasTopSpacing}>{text}</S.Divider>
);

export default Divider;

Divider.defaultProps = {
  hasTopSpacing: true,
};

Divider.propTypes = {
  text: PropTypes.string.isRequired,
  hasTopSpacing: PropTypes.bool,
};
